import React, {useContext} from 'react';
import {matchPath, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {observer} from 'mobx-react-lite';
import {Context} from '../index';
import {CATALOG_ROUTE, ITEM_ROUTE, ROLE_ADMIN, SHOP_ROUTE} from '../util/Constants';
import {authRoutes, adminRoutes, unauthRoutes} from '../routes';
import Landing from './home/Landing';
import Catalog from './items/Catalog';
import CategoryCatalog from './items/CategoryCatalog';
import Item from './items/Item';

/**
 * Подложка для модалки товара: без state.background показываем каталог, чтобы фон не пропадал.
 */
function itemUnderlayLocation() {
    return {pathname: SHOP_ROUTE, search: '', hash: '', state: null, key: 'item-underlay'};
}

/**
 * Все маршруты витрины + модалка товара поверх «фонового» location (см. state.background при navigate).
 */
const ShopRoutesWithModal = observer(() => {
    const location = useLocation();
    const {user} = useContext(Context);

    const itemMatch = matchPath({path: `${ITEM_ROUTE}/:id`, end: true}, location.pathname);
    const background = location.state?.background;
    const routesLocation = itemMatch ? background ?? itemUnderlayLocation() : location;

    return (
        <>
            <Routes location={routesLocation}>
                <Route index element={<Landing/>}/>
                <Route path="catalog/:categoryKey" element={<CategoryCatalog/>}/>
                <Route path="catalog" element={<Catalog/>}/>
                {user.isAuth &&
                    authRoutes.map(({path, Component}) => <Route key={path} path={path} element={<Component/>}/>)}
                {user.userRole === ROLE_ADMIN &&
                    adminRoutes.map(({path, Component}) => <Route key={path} path={path} element={<Component/>}/>)}
                {unauthRoutes.map(({path, Component}) => (
                    <Route key={path} path={path} element={<Component/>}/>
                ))}
                <Route path="*" element={<Navigate to={CATALOG_ROUTE} replace/>}/>
            </Routes>
            {itemMatch ? <Item/> : null}
        </>
    );
});

export default ShopRoutesWithModal;
